/* Credits
======================================== */
console.log("HE07132534: Code by Carlos Mayo (https://carlosmayo.info/)");

/* Global constants
==================================== */
const body = $("body");

/* Easing
==================================== */
const ease = $.bez([0.45, 0.05, 0.19, 1]),
  speed = 300;

/* Viewport
==================================== */
function heightViewport() {
  document.documentElement.style.setProperty(
    "--height-viewport",
    window.innerHeight + "px"
  );
}
heightViewport();

/* Consentik app
==================================== */
setTimeout(function () {
  let cookiesCssMain = $('link[href*="/assets/main.css"]');
  if (cookiesCssMain.length) {
    cookiesCssMain[0].disabled = true;
  }
  let cookiesCssFull = $('link[href*="/assets/full.css"]');
  if (cookiesCssFull.length) {
    cookiesCssFull[0].disabled = true;
  }
  $("#ot-style, #ot-root-css, #cst-button-pos")?.remove();
}, 1000);

/* Device detection
==================================== */
const isMobile = window.matchMedia(
  "(hover: none) and (pointer: coarse)"
).matches;

/* Mobile
======================================== */
if (isMobile) {
  // Selector
  body.addClass("devices");

  // Pseudoclass :active on devices
  document.addEventListener("touchstart", function () {}, { passive: true });

  // Resize Functions
  window.addEventListener("orientationchange", function () {
    setTimeout(function () {
      heightViewport();
    }, 50);
  });
}

/* Desktop
======================================== */
if (!isMobile) {
  // Selector
  body.addClass("desktop");

  // Resize functions
  $(window).resize(function () {
    heightViewport();
  });

  // Coordinates
  if (body.data("layout") == "index") {
    $(document).mousemove(function (e) {
      let x = e.clientX.toString();
      let y = e.clientY.toString();
      if (x < 10) x = "0" + x;
      if (x < 100) x = "0" + x;
      if (x < 1000) x = "0" + x;
      if (y < 10) y = "0" + y;
      if (y < 100) y = "0" + y;
      if (y < 1000) y = "0" + y;
      $("#h-left").text(x.slice(0, 2));
      $("#e-left").text(x.slice(2));
      $("#h-right").text(y.slice(0, 2));
      $("#e-right").text(y.slice(2));
    });
  }
}

/* Clearing format
==================================== */
if ($(".clear-format").length) {
  $(".clear-format").html(function (i, html) {
    return html.replace(/&nbsp;/g, " ");
  });
  $(
    ".clear-format *:not(.exclude, br, table), .shopify-section.clear-format"
  ).each(function () {
    $(this)
      .filter(function () {
        return $(this).text().trim().length == 0;
      })
      .remove();
  });
}

/* Init
==================================== */
if (body.data("layout") != "index") {
  setTimeout(function () {
    $("#loader").fadeOut(speed * 2, function () {
      $(this).addClass("completed");
      body.removeClass("transition");
    });
    $("#he-lock-up_wrapper").fadeOut(speed * 2);
  }, speed * 2);
} else {
  setTimeout(function () {
    $("#loader").fadeOut(speed * 2, function () {
      $(this).addClass("completed");
      $("#he-lock-up_wrapper").addClass("visible");
      body.removeClass("transition");
    });
  }, 1000);
}

/* AG Message
==================================== */
const $agMessage = $("#archive-gallery-message");
if ($agMessage.length) {
  var titles = [];
  $(".product-infos_title").each(function () {
    titles.push($(this).text());
  });
  function showAGMessage() {
    setTimeout(function () {
      var title = titles[Math.floor(Math.random() * titles.length)];
      $agMessage.find("#archive-gallery-message-product").text(title);
      $agMessage.stop().slideToggle(speed * 2, ease, function () {
        setTimeout(function () {
          $agMessage.stop().slideToggle(speed * 2, ease);
        }, 5000);
      });
    }, 10000);
  }
  if (!$("#password-wrapper").is(":visible")) {
    showAGMessage();
    var agCountdown;
    var agTimer = function () {
      agCountdown = setInterval(function () {
        showAGMessage();
      }, 15000);
    };
    agTimer();
    $(window)
      .focus(function () {
        clearInterval(agCountdown);
        agTimer();
      })
      .blur(function () {
        clearInterval(agCountdown);
      });
  }
  // $agMessage.find('.popup-message_close').click(function(){
  // 	clearTimeout(agCountdown);
  // 	$agMessage.slideToggle(speed*2, ease);
  // });
}

/* Banner
==================================== */
const banner = $("#banner");
if (banner.length) {
  // Remove
  if (sessionStorage.getItem("he-banner") == "close") {
    banner.remove();
  } else {
    const bannerEl = banner.get(0);
    const bannerItems = banner.find(".banner-item").toArray();
    let bannerIndex = bannerItems.findIndex((item) =>
      item.classList.contains("is-active")
    );
    if (bannerIndex < 0) {
      bannerIndex = 0;
    }

    // Activate: sets colors + visible bar, no transition between bars
    function activateBanner(index) {
      bannerItems.forEach((item, i) => {
        item.classList.toggle("is-active", i === index);
      });
      const active = bannerItems[index];
      if (active) {
        bannerEl.style.setProperty(
          "--color-banner--bg",
          active.dataset.bg || "black"
        );
        bannerEl.style.setProperty(
          "--color-banner--text",
          active.dataset.color || "white"
        );
      }
    }

    if (bannerItems.length) {
      activateBanner(bannerIndex);
    }

    // Cycle through bars, each with its own display duration
    let timerBanner;
    function scheduleBanner() {
      clearTimeout(timerBanner);
      const active = bannerItems[bannerIndex];
      const duration = (active && parseFloat(active.dataset.duration)) || 5;
      timerBanner = setTimeout(function () {
        bannerIndex = (bannerIndex + 1) % bannerItems.length;
        activateBanner(bannerIndex);
        scheduleBanner();
      }, duration * 1000);
    }
    if (bannerItems.length > 1) {
      scheduleBanner();
    }

    // Theme editor: focus the bar being edited, resume cycling on deselect
    bannerEl.addEventListener("shopify:block:select", function (event) {
      const index = bannerItems.indexOf(event.target);
      if (index > -1) {
        clearTimeout(timerBanner);
        bannerIndex = index;
        activateBanner(bannerIndex);
      }
    });
    bannerEl.addEventListener("shopify:block:deselect", function () {
      if (bannerItems.length > 1) {
        scheduleBanner();
      }
    });

    // Close banner
    $("#banner-close").click(function () {
      clearTimeout(timerBanner);
      banner.slideUp(speed * 2, ease, function () {
        sessionStorage.setItem("he-banner", "close");
      });
    });
  }
}

/* Menus
==================================== */
function showMenu(menu) {
  if (menu.length && !body.hasClass("transition")) {
    body.addClass("transition");
    menu.addClass("in").show();
    menu.find(".menu-desktop").toggle(
      "slide",
      {
        direction: "up",
        easing: ease,
        complete: function () {
          menu.removeClass("in");
          body.removeClass("transition");
        },
      },
      speed * 2
    );
  }
}

function hideMenu(menu) {
  if (menu.length && !body.hasClass("transition")) {
    body.addClass("transition");
    menu.addClass("out");
    menu.find(".menu-desktop").toggle(
      "slide",
      {
        direction: "up",
        easing: ease,
        complete: function () {
          menu.hide().removeClass("out");
          body.removeClass("transition");
        },
      },
      speed * 2
    );
    $("[data-menu]").removeClass("active");
  }
}

$("[data-menu]").click(function () {
  let t = $(this);
  let menu = $(t.data("menu"));
  if ($(".menu-desktop--wrapper").not(menu).is(":visible")) {
    $(".menu-desktop--wrapper:visible").hide().find(".menu-desktop").hide();
    menu.show();
    menu.find(".menu-desktop").show();
    $("[data-menu]").not(t).removeClass("active");
    t.addClass("active");
  } else {
    t.toggleClass("active");
    if (menu.is(":visible")) {
      hideMenu(menu);
    } else {
      showMenu(menu);
    }
  }
});

$(".menu-desktop--wrapper")
  .click(function () {
    hideMenu($(this));
  })
  .find(".menu-desktop")
  .click(function (e) {
    e.stopPropagation();
  });

if (!isMobile) {
  $("[data-hover]").hover(
    function () {
      if (window.innerWidth > 1280) {
        $($(this).data("hover"))?.addClass("active");
      }
    },
    function () {
      if (window.innerWidth > 1280) {
        $($(this).data("hover"))?.removeClass("active");
      }
    }
  );
}

/* Submenus
==================================== */
function showSubmenu(submenu) {
  if (submenu.length) {
    $("#menu-mobile").hide();
    $("#submenu-close").html(submenu.data("title"));
    submenu.show();
  }
}

function hideSubmenu() {
  $(".submenu-mobile").hide();
  $("#submenu-close").empty();
  $(".submenu-nav--links").hide();
  $(".submenu-nav--header").removeClass("active");
  $("#menu-mobile").show();
}

$("[data-submenu").click(function () {
  showSubmenu($($(this).data("submenu")));
});

$("#submenu-close").click(function () {
  hideSubmenu();
});

/* Search
======================================== */
// $('#menu-mobile .form-search input').keyup(function(){
// 	let t = $(this);
// 	if(t.val() != ''){
// 		t.next('button').show();
// 	}else{
// 		t.next('button').hide();
// 	}
// });

/* Submenu: nav
======================================== */
$(".submenu-nav--header").click(function () {
  let t = $(this);
  let n = t.next(".submenu-nav--links");
  if (window.innerWidth <= 840) {
    if (n.length && !n.hasClass("transition")) {
      n.addClass("transition");
      if ($(".submenu-nav--links").not(n).is(":visible")) {
        $(".submenu-nav--links:visible")
          .slideUp(speed * 2, ease)
          .prev()
          .removeClass("active");
      }
      t.toggleClass("active");
      n.slideToggle(speed * 2, ease, function () {
        n.removeClass("transition");
      });
    }
  }
});

/* Footer: nav
======================================== */
$(".footer-nav--header").click(function () {
  let t = $(this);
  let n = t.next(".footer-nav--links");
  if (window.innerWidth <= 840) {
    if (n.length && !n.hasClass("transition")) {
      n.addClass("transition");
      if ($(".footer-nav--links").not(n).is(":visible")) {
        $(".footer-nav--links:visible")
          .slideUp(speed * 2, ease)
          .prev()
          .removeClass("active");
      }
      t.toggleClass("active");
      n.slideToggle(speed * 2, ease, function () {
        n.removeClass("transition");
      });
    }
  }
});

/* Sections
======================================== */
$(".module-section_title").click(function () {
  let t = $(this);
  let n = t.next(".collapsed");
  let p = t.closest(".module-sections");
  if (n.length && !$(".module-section_title.transition").length) {
    t.addClass("transition");
    if (p.find(".collapsed").not(n).is(":visible")) {
      p.find(".module-section_title").removeClass("active");
      t.addClass("active");
      if ($(".focal").length) {
        $(".focal").removeClass("active");
        t.parents(".module-article_products-wrapper")
          .find(".focal")
          .eq(t.parent().index())
          .addClass("active");
      }
      p.find(".collapsed:visible").slideUp(speed * 2, ease, function () {
        n.slideDown(speed * 2, ease, function () {
          t.removeClass("transition");
        });
      });
    } else {
      t.toggleClass("active");
      if ($(".focal").length) {
        t.parents(".module-article_products-wrapper")
          .find(".focal")
          .eq(t.parent().index())
          .toggleClass("active");
      }
      n.slideToggle(speed * 2, ease, function () {
        t.removeClass("transition");
      });
    }
  }
});

/* Selectors
======================================== */
function updateSelect(id, target) {
  body.append(
    '<span id="' +
      id +
      '" style="display: none;">' +
      target.find("option:checked").text() +
      "</span>"
  );
  target.css(
    "width",
    "calc(" + $("#" + id).width() + "px + var(--gap-s) + var(--gap-xs)*2)"
  );
  $("#" + id).remove();
}

/* Currency
======================================== */
const currencySelector = $("#currency-selector");

function changeCurrency(conversion) {
  $("html").attr("currency", conversion);
  fetch("https://api.exchangerate-api.com/v4/latest/EUR")
    .then((response) => response.json())
    .then((data) => {
      let x = data.rates["EUR"];
      let y = data.rates[conversion];
      $(".money").each(function (e) {
        let t = $(this);
        let val = parseFloat(t.attr("val").replace(/[^\d]/g, ""));
        let money = (y / x) * val;
        let txt = money.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        t.text(txt.replaceAll(",", "."));
      });
    });
}

if (currencySelector.length) {
  let currency = localStorage.getItem("he-currency");
  if (currency && currency != "EUR") {
    changeCurrency(currency);
    currencySelector
      .find("option[value=" + currency + "]")
      .attr("selected", "selected");
  }

  // Init
  setTimeout(function () {
    updateSelect("currency_selected", currencySelector);
  }, speed * 2);

  // Update
  currencySelector.change(function () {
    let currency = $(this).val();
    changeCurrency(currency);
    localStorage.setItem("he-currency", currency);
    updateSelect("currency_selected", currencySelector);
  });
} else {
  localStorage.removeItem("he-currency");
}

/* Location
======================================== */
const locationSelector = $("#location-selector");
if (locationSelector.length) {
  // Init
  setTimeout(function () {
    updateSelect("location_selected", locationSelector);
  }, speed * 2);

  // Update
  locationSelector.change(function () {
    updateSelect("location_selected", locationSelector);
    $("#form-location").submit();
  });
}

/* Product selectors
======================================== */
var selectors = $(".product-select");
if (selectors.length) {
  selectors.each(function () {
    let t = $(this);

    // Init
    setTimeout(function () {
      updateSelect(t.attr("id") + t.index(), t);
    }, speed * 2);

    // Update
    t.change(function () {
      updateSelect(t.attr("id") + t.index(), t);
    });
  });
}

/* Drawers
======================================== */
function showDrawer(drawer) {
  if (drawer.length && !body.hasClass("transition")) {
    body.addClass("transition");
    drawer.addClass("in").show();
    drawer.find(".drawer").toggle(
      "slide",
      {
        direction: drawer.data("direction"),
        easing: ease,
        complete: function () {
          drawer.find("label:first-of-type input")?.focus();
          drawer.removeClass("in");
          body.removeClass("transition");
          if (drawer.is("#drawer-menu")) {
            hideSubmenu();
          }
        },
      },
      speed * 2
    );
  }
}

function hideDrawer(drawer) {
  if (drawer.length && !body.hasClass("transition")) {
    body.addClass("transition");
    drawer.addClass("out");
    drawer.find(".drawer").toggle(
      "slide",
      {
        direction: drawer.data("direction"),
        easing: ease,
        complete: function () {
          drawer.find("label:first-of-type input")?.blur().val("");
          drawer.hide().removeClass("out");
          body.removeClass("transition");
        },
      },
      speed * 2
    );
  }
}

$("[data-drawer]").click(function () {
  showDrawer($($(this).data("drawer")));
});

$(".drawer-wrapper")
  .click(function () {
    hideDrawer($(this));
  })
  .find(".drawer")
  .click(function (e) {
    e.stopPropagation();
  })
  .find(".drawer-close")
  .click(function () {
    hideDrawer($(this).closest(".drawer-wrapper"));
  });

if (!isMobile) {
  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      if ($(".drawer-wrapper").is(":visible")) {
        if (!$(".popup-wrapper").is(":visible")) {
          hideDrawer($(".drawer-wrapper:visible"));
        }
      }
    }
  });
}

/* Popups
======================================== */
function showPopup(popup, timer) {
  setTimeout(function () {
    body.addClass("transition");
    popup
      .fadeIn(speed * 2, function () {
        popup.find("label:first-of-type input")?.focus();
        body.removeClass("transition");
      })
      .addClass("completed");
  }, timer);
}

function hidePopup(popup) {
  body.addClass("transition");
  popup.removeClass("completed").fadeOut(speed * 2, function () {
    body.removeClass("transition");
  });
}

$("[data-popup]").click(function () {
  showPopup($($(this).data("popup")), 0);
});

$(".popup-wrapper")
  .click(function () {
    hidePopup($(this));
  })
  .find(".popup")
  .click(function (e) {
    e.stopPropagation();
  })
  .find(".popup-close")
  .click(function () {
    hidePopup($(this).closest(".popup-wrapper"));
  });

if (!isMobile) {
  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      if ($(".popup-wrapper").is(":visible")) {
        hidePopup($(".popup-wrapper:visible"));
      }
    }
  });
}

/* Newsletter
======================================== */
window.addEventListener("load", function () {
  const newsletter = document.getElementById("popup-newsletter");
  if (!newsletter) return;

  if (sessionStorage.getItem("he-newsletter") !== "close") {
    setTimeout(() => {
      newsletter.classList.add("active");
    }, newsletter.getAttribute("data-timer") * 1000);
  } else {
    newsletter.classList.remove("active");
  }

  const closePopup = () => {
    newsletter.classList.remove("active");
    sessionStorage.setItem("he-newsletter", "close");
  };

  const closeButton = newsletter.querySelector(".popup-close");
  const overlay = newsletter.querySelector(".popup-overlay");
  closeButton.removeEventListener("click", closePopup);
  overlay.removeEventListener("click", closePopup);

  closeButton.addEventListener("click", closePopup);
  overlay.addEventListener("click", closePopup);
});

/* Pop–ups
======================================== */
function hidePopUpOld() {
  if (window.CartDrawer && window.CartDrawer.isOpen()) {
    window.CartDrawer.close();
    return;
  }
  body.addClass("transition").removeClass("overlay");
  $(".module-popup:visible").toggle(
    "slide",
    {
      direction: "right",
      easing: ease,
      complete: function () {
        body.removeClass("transition");
        $(this).find(".form-field").blur().val("");
      },
    },
    speed * 2
  );
  $(".module-popup_content").fadeOut(speed);
}

$("[data-popup]").click(function (e) {
  let t = $(this);
  let popup = $(t.data("popup"));
  if (!body.hasClass("transition")) {
    e.stopPropagation();
    body.addClass("transition overlay");
    popup.toggle(
      "slide",
      {
        direction: "right",
        easing: ease,
        complete: function () {
          popup.find(".module-popup_content").fadeIn(speed * 2, function () {
            body.removeClass("transition");
            popup.find("input").first().focus();
          });
        },
      },
      speed * 2
    );
  }
});

$(".module-popup").click(function (e) {
  e.stopPropagation();
});

$(".trigger-popup_close:not([data-cart-close])").click(function () {
  hidePopUpOld();
});

$(document).click(function () {
  if ($(".module-popup:visible").length) {
    hidePopUpOld();
  }
});

/* Scroll Down
==================================== */
$("#scroll-down").click(function () {
  $(this).addClass("transition").hide().removeClass("active");
  $("html, body").animate(
    {
      scrollTop: window.innerHeight / 2,
    },
    speed * 2,
    ease
  );
});

$(window).scroll(function () {
  if ($("#scroll-down").length) {
    if ($(window).scrollTop() > 0) {
      $("#scroll-down").addClass("transition").hide();
    } else {
      $("#scroll-down").fadeIn(speed * 2, function () {
        $(this).removeClass("transition");
      });
    }
  }
});

/* Switch cols
======================================== */
function setCols(cols) {
  $('.trigger[data-cols="' + cols + '"]')
    .addClass("active")
    .siblings()
    .removeClass("active");
  $(".module-collection").attr("data-cols", cols);
  sessionStorage.setItem("he-cols", cols);
}
if ($("[data-cols]").length) {
  if (sessionStorage.getItem("he-cols") === "max") {
    setCols("max");
  }
  $(".trigger[data-cols]").click(function () {
    $(window).scrollTop(0);
    setCols($(this).data("cols"));
  });
}

/* Focals
======================================== */
$(".focal").click(function (index) {
  let t = $(this)
    .parent()
    .next()
    .find(".module-section_title")
    .eq($(this).index());
  let n = t.next(".collapsed");
  if (n.length) {
    if (!t.hasClass("transition")) {
      t.addClass("transition");
      if ($(".module-section_title + .collapsed").not(n).is(":visible")) {
        $(".module-section_title").removeClass("active");
        $(".focal").removeClass("active");
        t.addClass("active");
        $(this).addClass("active");
        $(".module-section_title + .collapsed:visible").slideUp(
          speed * 2,
          ease,
          function () {
            n.slideDown(speed * 2, ease, function () {
              t.removeClass("transition");
            });
          }
        );
      } else {
        t.toggleClass("active");
        $(this).toggleClass("active");
        n.slideToggle(speed * 2, ease, function () {
          t.removeClass("transition");
        });
      }
    }
  }
});

/* Filters Trigger
======================================== */
$(".trigger-filter").click(function () {
  var t = $(this);
  if (!t.hasClass("transition")) {
    t.addClass("transition")
      .toggleClass("active")
      .siblings(".trigger-filter_close")
      .toggle()
      .parent()
      .next(".module-filters")
      .slideToggle(speed * 2, ease, function () {
        t.removeClass("transition");
      });
  }
});
$(".trigger-filter_close").click(function () {
  var t = $(this).siblings(".trigger-filter");
  if (!t.hasClass("transition")) {
    t.addClass("transition")
      .removeClass("active")
      .siblings(".trigger-filter_close")
      .hide()
      .parent()
      .next(".module-filters")
      .slideUp(speed * 2, ease, function () {
        t.removeClass("transition");
      });
  }
});

/* Filters
======================================== */
$(".filter:not(.sort)").click(function () {
  var t = $(this),
    active = t.parents(".filters-wrapper").find("input"),
    type = t.data("type"),
    val = t.data("filter");

  //Pos
  $(window).scrollTop(0);

  //Active/deactive filter
  t.toggleClass("active");

  //Hide projects
  $(".product, .universe-article").addClass("active-" + type);

  //Filter
  active.toggleClass(val);
  var fa = active.attr("class"),
    ca = fa.split(/\s+/);
  $.each(ca, function (index, v) {
    $(".product" + v).removeClass("active-" + type);
    $(".universe-article" + v).removeClass("active-" + type);
  });

  //Clear
  if ($('.filter[data-type="' + type + '"].active').length == 0) {
    $(".product, .universe-article").removeClass("active-" + type);
  }

  //Products count
  if (body.hasClass("template-blog")) {
    var count = $(".universe-article:visible").length;
    $(".module-title_title .counter").text(count);
  } else {
    $(".module-collection_wrapper").each(function () {
      var t = $(this),
        count = t.find(
          ".product:not(.active-discount, .active-categorybf, .active-typology, .active-material, .active-gender, .active-color, .active-size)"
        ).length;
      t.find(".module-title_title .counter").text(count);
      if (count == 0) {
        if (!t.is(":first-child")) {
          t.show().hide();
        }
      } else {
        t.show();
      }
    });
  }

  //Filters active acount
  var count = $(".filter:not(.sort).active").length;
  $(".trigger-filter .counter").text(count);

  if (count > 0) {
    body.addClass("filter-active");
    $(".trigger-filter_clear").show();
  } else {
    body.removeClass("filter-active");
    $(".trigger-filter_clear").hide();
  }
});

//Clear filters
$(".trigger-filter_clear").click(function () {
  $(".trigger-filter_clear").hide();
  $(".trigger-filter .counter").text("0");
  $(".filter:not(.sort)").removeClass("active");
  $(".filters-wrapper input").removeClass();
  $(".product, .universe-article").removeClass(
    "filtered active-discount active-typology active-material active-gender active-color active-size active-year active-tag active-categorybf active-category"
  );
  var target = $(".product");
  if (body.hasClass("template-blog")) {
    target = $(".module-list_row-wrapper");
  }
  $(".module-title_title .counter").text(target.length);
});

/* Sort
======================================== */
function sortList(t, k, p, target) {
  target
    .sort(function (a, b) {
      if (!t.hasClass("active")) {
        return $(b).data(k) > $(a).data(k) ? 1 : -1;
      } else {
        return $(b).data(k) < $(a).data(k) ? 1 : -1;
      }
    })
    .prependTo(p);
}
$("[data-sort]").click(function () {
  var t = $(this),
    k = t.data("sort"),
    p = $(".module-list_content"),
    target = p.find(".module-list_row-wrapper:not([data-" + k + '="null"])');
  t.toggleClass("active");
  $("[data-sort]").not(t).removeClass("active");
  sortList(t, k, p, target);
  if (body.hasClass("template-blog")) {
    (p = $(".module-gallery")), (target = p.find(".module-gallery_block"));
    sortList(t, k, p, target);
  }
});

//Sort
$(".filter.sort").click(function () {
  var t = $(this),
    k = t.data("value");
  t.siblings().removeClass("active");
  if (!t.hasClass("active")) {
    t.addClass("active");
    $(".module-collection").each(function () {
      var p = $(this);
      p.find(".product:not([data-" + k + '="null"])')
        .sort(function (a, b) {
          if (!t.hasClass("invert")) {
            return $(b).data(k) < $(a).data(k) ? 1 : -1;
          } else {
            return $(b).data(k) > $(a).data(k) ? 1 : -1;
          }
        })
        .prependTo(p);
    });
    // }else{
    // 	t.removeClass('active');
    // 	$('.module-collection').each(function(){
    // 		var t = $(this);
    // 		t.find('.product[data-'+k+']').sort(function(a, b){
    // 			return $(b).data('pos') < $(a).data('pos') ? 1 : -1;
    // 		}).prependTo(t);
    // 	})
  }
});

/* Timer
======================================== */
function setInitDate() {
  var userDate = new Date().getTime();
  localStorage.setItem("he-session", userDate);
}
if ($(".timer-wrapper").length) {
  if (localStorage.getItem("he-session") === null) {
    setInitDate();
  }

  $(".timer-wrapper").each(function () {
    let t = $(this);
    let timer = t.data("timer") * 60000;
    let warning = t.data("warning");

    let date = JSON.parse(localStorage.getItem("he-session")) + timer;
    let countdown = setInterval(function () {
      var now = new Date().getTime();
      var time = date - now;
      var day = Math.floor(time / (1000 * 60 * 60 * 24));
      var hour = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var mins = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
      var secs = Math.floor((time % (1000 * 60)) / 1000);

      day = day < 10 ? "0" + day : day;
      hour = hour < 10 ? "0" + hour : hour;
      mins = mins < 10 ? "0" + mins : mins;
      secs = secs < 10 ? "0" + secs : secs;

      if (t.hasClass("loop")) {
        if (time < 0) {
          setInitDate();
          date = JSON.parse(localStorage.getItem("he-session")) + timer;

          var now = new Date().getTime();
          var time = date - now;
          var day = Math.floor(time / (1000 * 60 * 60 * 24));
          var hour = Math.floor(
            (time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          var mins = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
          var secs = Math.floor((time % (1000 * 60)) / 1000);

          day = day < 10 ? "0" + day : day;
          hour = hour < 10 ? "0" + hour : hour;
          mins = mins < 10 ? "0" + mins : mins;
          secs = secs < 10 ? "0" + secs : secs;
        }
        t.find(".days").html(day);
        t.find(".hours").html(hour);
        t.find(".minutes").html(mins);
        t.find(".seconds").html(secs);
      } else {
        if (time < 2) {
          clearInterval(countdown);
          if (warning) {
            t.text(warning);
          }
        } else {
          t.find(".days").html(day);
          t.find(".hours").html(hour);
          t.find(".minutes").html(mins);
          t.find(".seconds").html(secs);
        }
      }
    }, 1000);
  });
} else {
  localStorage.removeItem("he-session");
}

/* Countdowns
======================================== */
$(".countdown-wrapper").each(function () {
  let t = $(this);
  let timer = t.data("timer");
  let warning = t.data("warning");

  if (timer) {
    let time = 60 * timer;
    let countdown = setInterval(function () {
      time -= 1000;
      var mins = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
      var secs = Math.floor((time % (1000 * 60)) / 1000);
      mins = mins < 10 ? "0" + mins : mins;
      secs = secs < 10 ? "0" + secs : secs;
      if (time < 0) {
        clearInterval(countdown);
        if (warning) {
          t.text(warning);
        }
      } else {
        t.find(".minutes").text(mins);
        t.find(".seconds").text(secs);
      }
    }, 1000);
  } else {
    let date = new Date(t.data("date")).getTime();
    let countdown = setInterval(function () {
      var d = new Date();
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = 1; /* UTC CET Time */
      var cet = utc + 3600000 * offset;
      var now = new Date(cet).getTime();
      var time = date - now;
      var day = Math.floor(time / (1000 * 60 * 60 * 24));
      var hour = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var mins = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
      var secs = Math.floor((time % (1000 * 60)) / 1000);

      day = day < 10 ? "0" + day : day;
      hour = hour < 10 ? "0" + hour : hour;
      mins = mins < 10 ? "0" + mins : mins;
      secs = secs < 10 ? "0" + secs : secs;

      if (time < 0) {
        clearInterval(countdown);
        if (warning) {
          t.text(warning);
        }
      } else {
        t.find(".days").html(day);
        t.find(".hours").html(hour);
        t.find(".minutes").html(mins);
        t.find(".seconds").html(secs);
      }
    }, 1000);
  }
});

/* Shuffle
======================================== */
$.fn.shuffle = function () {
  let allElems = this.get();
  let getRandom = function (max) {
      return Math.floor(Math.random() * max);
    },
    shuffled = $.map(allElems, function () {
      let random = getRandom(allElems.length);
      let randEl = $(allElems[random]).clone(true)[0];
      allElems.splice(random, 1);
      return randEl;
    });
  this.each(function (i) {
    $(this).replaceWith($(shuffled[i]));
  });
  return $(shuffled);
};

$(".shuffle").each(function () {
  let t = $(this);
  if (t.find(".product").length > 13) {
    t.find(".product").shuffle();
    t.find(".product:nth-child(13)").nextAll().remove();
  }
});

// lazySizes.autoSizer.checkElems();

/* Cart Qty
======================================== */
$(".item-quantity select").each(function () {
  $(this).change(function (e) {
    e.preventDefault();
    setTimeout(function () {
      $("#cart-update").click();
    }, 200);
  });
});

/* Shipping and Returns
======================================== */
const shippingSelector = $("#shipping-country");
function updateShippingSelect() {
  body.append(
    '<span class="shipping-country_selected" style="display: none">' +
      shippingSelector.find("option:checked").text() +
      "</span>"
  );
  shippingSelector.css(
    "width",
    "calc(" +
      $(".shipping-country_selected").width() +
      "px + var(--gap-s) + var(--gap-xs)*2)"
  );
  $(".shipping-country_selected").remove();
}
if (shippingSelector.length) {
  setTimeout(function () {
    updateShippingSelect();
  }, speed * 2);
  shippingSelector.change(function () {
    var o = $(this).find("option:checked"),
      price = o.attr("data-price"),
      delivery = o.attr("data-delivery");
    $("#shipping-price").html(price);
    $("#shipping-delivery").html(delivery);
    updateShippingSelect();
  });
}

/* Lazy Loading
======================================== */
function lazyLoading(t) {
  if (t.tagName == "IMG") {
    t.src = t.dataset.src;
  }
  if (t.tagName == "VIDEO") {
    var P = t.play();
    if (P !== undefined) {
      P.catch((error) => {
        if ($(t).hasClass("gif")) {
          t.classList.add("no-autoplay");
        } else {
          t.classList.add("controls");
          t.controls = true;
        }
      });
    }
  }
  t.classList.remove("lazy");
  t.classList.add("lazyloaded");
}

/* Observer Functions
======================================== */
var L = [].slice.call(document.querySelectorAll(".lazy"));
if ("IntersectionObserver" in window) {
  let l = new IntersectionObserver(function (E, observer) {
    E.forEach(function (e) {
      if (e.isIntersecting) {
        let t = e.target;
        lazyLoading(t);
        l.unobserve(t);
      }
    });
  });
  L.forEach(function (t) {
    l.observe(t);
  });
} else {
  L.forEach(function (t) {
    lazyLoading(t);
  });
}
